export default __webpack_public_path__ + "static/media/Group 6503@3x.c8cac4d1.png";